import { render } from "./InvOrthodontics.vue?vue&type=template&id=1feb7814"
import script from "./InvOrthodontics.vue?vue&type=script&lang=js"
export * from "./InvOrthodontics.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__